<template>
  <div class="list-category-news">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <h6 class="font-semibold m-0">Quản lý comment</h6>
        </a-row>
      </template>
      <a-table
        :loading="callingAPI"
        :columns="columns"
        :data-source="dataSource"
        :pagination="pagination"
        @change="handleTableChangePage"
        rowKey="id"
      >
       <template slot="createdBy" slot-scope="row">
        <span v-if="row.user && row.user.name"> {{row.user.name}}</span>
        </template>
        <template slot="status" slot-scope="row">
          <a-switch
            v-model="row.status"
            :loading="row.loadingActive"
            @change="handleUpdate(row)"
          />
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import {
  fetchComments,
  updateCommentStatus
} from "@/services/landing-page/comment-management";
import ENDPOINT from "@/config/endpoint";

export default {
  name: "ListUser",
  data() {
    return {
      callingAPI: false,
      backendUrl: ENDPOINT.BACKEND_URL,

      pagination: {
        total: 0,
        pageSize: 10,
        current: 1
      },
      

      dataSource: [],
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          class: "font-semibold",
          width: 100
        },
        {
          title: "ID bài viết",
          dataIndex: "article_id",
          class: "font-semibold",
          width: 100
        },
        {
          title: "Content",
          dataIndex: "content",
          class: "font-semibold",
          width: 250
        },
         {
          title: "Người tạo",
          scopedSlots: { customRender: "createdBy" },
          width: 100,
          align: "center"
        },
        {
          title: "Trạng thái",
          scopedSlots: { customRender: "status" },
          width: 100,
          align: "center"
        }
      ]
    };
  },
  async beforeMount() {
    await this.loadData();
  },
  methods: {
    async loadData(loading = true) {
      try {
        this.callingAPI = loading;
        const params = {
          per_page: this.pagination.pageSize,
          page: this.pagination.current
        };
        const response = await fetchComments(params);
        this.dataSource = response.data.data.map(d => ({
          ...d,
          status: d.status === 1,
          loadingActive: false
        }));
        this.pagination.total = response.data.total;
        this.callingAPI = false;
      } catch (error) {
        this.callingAPI = false;
      }
    },

    async handleTableChangePage(pagination) {
      this.pagination.current = pagination.current;
      await this.loadData();
    },

    async handleUpdate(row) {
      try {
        const formData = new FormData()
        formData.append("status", row.status ? 1 : 2);
        formData.append("_method", "PUT");
        const response = await updateCommentStatus(row.id, formData);
        if (response.status === 1) {
          this.$notification.success({
            message: 'Thành công',
            description: 'Cập nhật trạng thái thành công.',
          });
        } else {
          this.$notification.error({
            message: 'Thất bại',
            description: 'Cập nhật trạng thái thất bại.',
          });
        }
      } catch (error) {
        console.log(error)
      }
    },
  }
};
</script>

<style lang="scss" scoped>
</style>